export const SUPPORTED_COUNTRIES_LINK =
  String(process.env.NEXT_PUBLIC_SUPPORTED_COUNTRIES_URL || "").trim() ||
  "/supported-countries";

export const DEFAULT_SUPPORTED_COUNTRIES_RETURN_TO = "/signup";

export function safeSupportedCountriesReturnTo(value?: string | null) {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return DEFAULT_SUPPORTED_COUNTRIES_RETURN_TO;
  }

  try {
    const parsed = new URL(value, "https://www.jobolar.ai");
    if (
      parsed.origin !== "https://www.jobolar.ai" ||
      parsed.pathname === "/supported-countries"
    ) {
      return DEFAULT_SUPPORTED_COUNTRIES_RETURN_TO;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return DEFAULT_SUPPORTED_COUNTRIES_RETURN_TO;
  }
}

export function supportedCountriesHref(returnTo: string) {
  const separator = SUPPORTED_COUNTRIES_LINK.includes("?") ? "&" : "?";
  return `${SUPPORTED_COUNTRIES_LINK}${separator}returnTo=${encodeURIComponent(
    safeSupportedCountriesReturnTo(returnTo),
  )}`;
}

export const EMAIL_AUTO_APPLY_COUNTRIES = {
  Africa: [
    "Angola", "Botswana", "Cameroon", "Ethiopia", "Gambia", "Ghana", "Kenya",
    "Liberia", "Mozambique", "Namibia", "Nigeria", "Rwanda", "Senegal",
    "Sierra Leone", "Uganda", "Zambia", "Zimbabwe",
  ],
  Europe: [
    "Austria", "Belgium", "Bulgaria", "Croatia", "Cyprus", "Czechia", "Denmark",
    "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Iceland",
    "Ireland", "Italy", "Latvia", "Liechtenstein", "Lithuania", "Luxembourg",
    "Malta", "Netherlands", "Norway", "Poland", "Portugal", "Romania", "Slovakia",
    "Slovenia", "Spain", "Sweden", "Switzerland",
  ],
  "North America": ["Canada"],
} as const;

export const EMAIL_AUTO_APPLY_COUNTRY_COUNT = Object.values(
  EMAIL_AUTO_APPLY_COUNTRIES,
).reduce((total, countries) => total + countries.length, 0);
